import React from 'react';
import leaveSetAction from '../../actions/leaveSetAction';

class HolidayModal extends React.Component {
    constructor(props) {
        super(props);
        this.modalClose = this.modalClose.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleClick = this.handleClick.bind(this);
        this.state = {
            month: 0,
            year: 0,
            date: 0,
            title: "",
            warningMsg: "",
        };
    }
    static defaultProps = {
        styleHide: {
            visibility: 'hidden',
            background: 'rgba(0,0,0,0)',
        },
        styleShow: {
            visibility: 'visible',
            background: 'rgba(0,0,0,0.5)',
        },
        mthTxt: ["JAN", "FEB", "MAR", "APR", "MAY", "JUN", "JUL", "AUG", "SEP", "OCT", "NOV", "DEC"]
    };

    componentDidMount() {

    }
    handleChange(e) {
        let index = parseInt(e.currentTarget.getAttribute("data-index"));
        if (index == 0) {
            let sDate = e.target.value;
            let year, month, date;
            year = parseInt(sDate.split("-")[0]);
            month = parseInt(sDate.split("-")[1]) - 1;
            date = parseInt(sDate.split("-")[2]);

            this.setState({
                year: year, month: month, date: date
            });
        } else {
            let title = e.target.value;
            this.setState({
                title: title
            });
        }
    }
    handleClick(e) {
        if (this.props.action == 0) {
            //update to server
            if (this.state.date == 0 || this.state.year == 0) {
                return this.setState({ warningMsg: "Please select Date" });
            }
            if (this.state.title == "") {
                return this.setState({ warningMsg: "Name of holiday cannot be empty" });
            }
            let holiday = this.props.holiday;
            if (holiday.holiday) {
                holiday.holiday = holiday.holiday.concat({
                    year: this.state.year,
                    month: this.state.month,
                    date: this.state.date,
                    title: this.state.title
                });
            } else {
                holiday.holiday =[
                    {
                        year: this.state.year,
                        month: this.state.month,
                        date: this.state.date,
                        title: this.state.title
                    }
                ];
            }
            leaveSetAction.holiday(holiday);
            this.props.shouldModalClose(false);
        } else if(this.props.action == 1) {
            let holiday = this.props.holiday;
            holiday.holiday.splice(this.props.index, 1);
            leaveSetAction.holiday(holiday);
            this.props.shouldModalClose(false);
        } else if (this.props.action == 2){
            let holiday = this.props.holiday;
            holiday.event.splice(this.props.index, 1);
            leaveSetAction.holiday(holiday);
            this.props.shouldModalClose(false); 
        }else{
            //update to server
            if (this.state.date == 0 || this.state.year == 0) {
                return this.setState({ warningMsg: "Please select Date" });
            }
            if (this.state.title == "") {
                return this.setState({ warningMsg: "Name of Event cannot be empty" });
            }
            let holiday = this.props.holiday;
            if (holiday.event) {
                holiday.event = holiday.event.concat({
                    year: this.state.year,
                    month: this.state.month,
                    date: this.state.date,
                    title: this.state.title
                });
            } else {
                holiday.event =[
                    {
                        year: this.state.year,
                        month: this.state.month,
                        date: this.state.date,
                        title: this.state.title
                    }
                ];
            }
            leaveSetAction.holiday(holiday);
            this.props.shouldModalClose(false);
        }

    }

    modalClose() {
        this.props.shouldModalClose(false);
    }


    renderContent() {
        let s = this.state;
        let dates;
        if (s.year != 0) {
            dates = s.year + "-" + (s.month + 1 < 10 ? "0" + (s.month + 1) : (s.month + 1)) + "-" + (s.date < 10 ? "0" + s.date : s.date);
        }
        if (this.props.action == 0) {
            return (

                <div>
                    <form >
                        <div className="form-group">
                            <label htmlFor="title">Holiday:</label>
                            <input type="text" className="form-control" id="title" placeholder="Type Holiday Here"
                                value={this.state.title}
                                onChange={this.handleChange} data-index="1" />
                        </div>
                    </form>
                    <form >
                        <div className="form-group">
                            <label htmlFor="date">Date:</label>
                            <input type="date" className="form-control" id="date" value={dates ? dates : ""}
                                onChange={this.handleChange} data-index="0" />
                        </div>
                    </form>
                </div>
            );
        } else if(this.props.action == 1){
            let s = this.props.holiday.holiday[this.props.index];
            let dates;
            dates = s.date + "-" + (this.props.mthTxt[s.month]) + "-" + s.year;
            return (
                <div>
                    Are you sure to remove {this.props.holiday.holiday[this.props.index].title} on {dates}?
                </div>
            );
        } else if(this.props.action == 2){
            let s = this.props.holiday.event[this.props.index];
            let dates;
            dates = s.date + "-" + (this.props.mthTxt[s.month]) + "-" + s.year;
            return (
                <div>
                    Are you sure to remove {this.props.holiday.event[this.props.index].title} on {dates}?
                </div>
            );
        } else{
            return (
                <div>
                    <form >
                        <div className="form-group">
                            <label htmlFor="title">Event:</label>
                            <input type="text" className="form-control" id="title" placeholder="Type Event Here"
                                value={this.state.title}
                                onChange={this.handleChange} data-index="1" />
                        </div>
                    </form>
                    <form >
                        <div className="form-group">
                            <label htmlFor="date">Date:</label>
                            <input type="date" className="form-control" id="date" value={dates ? dates : ""}
                                onChange={this.handleChange} data-index="0" />
                        </div>
                    </form>
                </div>
            );
        }

    }
    render() {
        let style = this.props.modalClose ? this.props.styleShow : this.props.styleHide;
        return (
            <div>
                <div className="report-shadow" style={style}></div>
                <div className="report-modal" style={{ visibility: style.visibility }} ref="modal">
                    <div className="modal-header">
                        <h4 className="modal-title" >{this.props.title}</h4>
                    </div>

                    <div className="modal-body">
                        <div className="warning">{this.state.warningMsg}</div>
                        {this.renderContent()}
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-warning" onClick={this.handleClick}>Done</button>
                        <button type="button" className="btn btn-default" onClick={this.modalClose}>Cancel</button>
                    </div>
                </div>
            </div>
        );
    }
}


export default HolidayModal;


// WEBPACK FOOTER //
// ./app/setComponents/holidayComponents/holidayModal.js